import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {  NavigationExtras, Router } from '@angular/router';
import { DrawerService } from 'mis-crystal-design-system/drawer';
import { parseZone } from 'moment';
import { BookingActionsHeaderService } from 'src/app/bookings/shared/booking-actions-header/booking-actions-header.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import { CommonService } from 'src/app/shared/services/common.service';
import { DownloadAsCsvService } from 'src/app/shared/services/download-as-csv.service';
import { UtilService } from 'src/app/shared/services/util.service';
import { CommonBillingService } from '../shared/common-billing.service';
import { InvoiceSingleDetailsComponent } from './invoice-sigle-details/invoice-single-details.component';
import { InvoiceViewService } from './invoice-view.service';
import { CreateBookingService } from 'src/app/bookings/create-booking/create-booking.service';
import { DropdownItem } from 'mis-crystal-design-system/dropdown';

@Component({
  selector: 'app-invoice-view',
  templateUrl: './invoice-view.component.html',
  styleUrls: ['./invoice-view.component.scss']
})
export class InvoiceViewComponent implements OnInit {

  public isLoading = false;
  isSpinning = false;
  public config: any;
  public startDate: any;
  public endDate: any;

  public inputControlStartDate: any;
  public inputControlEndDate: any;
  public isAutoReload = false;
  public selectedInvoices = [];
  public selectedInvoiceDetailed = [];
  public allInvoicesSelected = false;
  public showCheckboxHyphen = false;
  public invoiceDetails: any = [];
  public searchTimer: any;
  public formDetails: FormGroup;
  public searchInput: any;
  public invoiceFilterConfig: any;
  public bookingTypeConfig: any;
  public cityConfig: any;
  public officeConfig: any;
  public vendorCabStatusConfig: any;
  public offices: any;
  public officeOptions: any;
  public showHeader = true;
  public tabularConfigObj: any;
  public tabularConfig: any;
  public sortAscending = true;
  public bulkInvoiceActions: any;
  public bulkInvoiceActionsObj: any;
  public showSuccessToast = false;
  public successMessage: string;
  public showErrorDialog = false;
  public errorMessage: any;

  isSendCommVisible = false;
  public sendInvoiceBookings: any;
  public singleBookingDetails: any;
  public showBookingDetails = false;
  public invoiceActionConfig: any;
  public invoiceActionsConfigObj: any;
  public invoiceActionBtnConfig: any;
  public invoiceActionBtnConfigObj: any;
  public disableActionsConfig: any;
  public dateMaxConfig: any;
  public displayInvalidDateError = false;
  public invoiceToastMessage: string;

  public invoiceTimer: any;
  public lastUpdateInterval: any;
  public now = 0;
  public downloadReportFailed: string;
  searchTimeout;
  showStatus = false;
  totalPages = 0;
  currentPage = 0;
  pageSize = 10;
  state: any;
  manualCutOff: any;
  nonEligibleBookings = [];
  eligibleBookings = [];
  showApproveModal = false;
  showRejectModal = false;
  showRejectReasonBlock = false;
  showApproveReasonBlock = false;
  approveReasonForAmountMismatch = false;
  showModal = false;
  reasonText: string;
  postDataForApproval = [];
  rejectinvoiceReasonConfig: any;
  approveinvoiceReasonConfig: any;
  maxLimit = 200;
  isSubmitReasonClicked = false;
  singleRejectedBooking: any[];
  showSuccessMessage: boolean;
  miscellConfig: any;

  public isTrackingVisible: boolean;

  pageIndexNew = 1;
  currentPageSize = 10;
  totalNoOfRows = 0;
  filteredInvoiceDetails: any = [];
  paginationId = 'invoicing-pagination';
  range = 5;

  reports: DropdownItem[] = [
    {
      label: 'Sign-In Report',
      value: 'Sign-In Report'
    },
    {
      label: 'Booking Report',
      value: 'Booking Report'
    }
  ];
  marshallAssignedIcon='assets/MarshallStatus-Assigned.svg'
  marshallRequestedIcon='assets/Marshall Status-Pending.svg'
  marshalAssigned = false;


  constructor(private commonService: CommonService, private utilService: UtilService,
              private authService: AuthService, private invoiceViewService: InvoiceViewService,
              private commonBillingService: CommonBillingService, private router: Router,

              private changeDetectorRef: ChangeDetectorRef,

              private downloadAsCsvService: DownloadAsCsvService,
              private bookingActionsHeaderService: BookingActionsHeaderService,
              private drawerSvc: DrawerService, private createBookingService: CreateBookingService) {
    if (this.router.getCurrentNavigation().extras.state) {
      this.state = this.router.getCurrentNavigation().extras.state;
    } else {
      this.state = null;
      this.invoiceToastMessage = "";
    }
    if (this.state && this.state["showApprovedToast"]) {
      this.showStatus = this.state["showApprovedToast"];
    }
  }

  ngOnInit() {
    this.createBookingService.showCreateBookingButton.next(true);

    this.formDetails = new FormGroup({
      bookingType: new FormControl('', Validators.required),
      city: new FormControl('', Validators.required),
      office: new FormControl(),
      vendorCabStatus: new FormControl()
    });
    this.getConfigs();
  }
  dismissToast() {
    this.showStatus = false;
    this.showSuccessMessage = false;
  }
  getConfigs() {
    this.commonService.fetchMiscConfig().subscribe((response: any) => {
      this.miscellConfig = response;
      if (response && response['pageSize']) {
        this.pageSize = parseInt(response['pageSize']);
        if (response['manualEndCutOff']) {
          this.manualCutOff = response['manualEndCutOff'];
        }
      }
    });
    this.commonService.fetchConfig().subscribe((response: any) => {
      this.config = this.commonService.getConfigForElementKey(response, 'Invoice Dashboard Page');
      this.invoiceFilterConfig = this.commonService.getConfigForElementKey(this.config, 'Filter Section');
      this.bulkInvoiceActions = this.commonService.getConfigForElementKey(this.config, 'Bulk Actions Ellipsis');
      this.setDateFilters();
      this.getEtsData();
      this.setFilterDefaults();
      this.setTabularConfigs();
      this.setBulkActionsConfigs();
      this.getBookingActionConfig();
      this.getDisableActionsConfig();
      this.setReasonConfig(response);
    });
    if (!this.commonService.workflowConfig) {
      this.commonService.fetchWorkflowConfig().subscribe((response: any) => {
        this.commonService.workflowConfig = response;
      });
    }
  }


  paymentFailed() {

  }

  setFilterDefaults() {
    if (this.invoiceFilterConfig && this.formDetails) {
      this.bookingTypeConfig = this.commonService.getConfigForElementKey(this.invoiceFilterConfig, 'Booking Type');
      this.cityConfig = this.commonService.getConfigForElementKey(this.invoiceFilterConfig, 'City');
      this.officeConfig = this.commonService.getConfigForElementKey(this.invoiceFilterConfig, 'Offices');

      this.formDetails.get('bookingType').setValue(this.bookingTypeConfig.config.defaultValue);
      this.formDetails.get('city').setValue(this.cityConfig.config.defaultValue);
      if (this.officeConfig.config.visibility.visible) {
        this.formDetails.get('office').setValue(this.officeConfig.config.defaultValue);
      }
      this.changeDetectorRef.detectChanges();
    }
  }

  selectedDate(dateValue: any) {
    this.startDate = dateValue.date.startDate ? parseZone(dateValue.date.startDate, 'DD/MM/YYYY') : '';
    this.endDate = dateValue.date.endDate ? parseZone(dateValue.date.endDate, 'DD/MM/YYYY') : '';
    if (this.endDate && this.startDate.isAfter(this.endDate, 'day')) {
      this.setDateFormControlError();
    } else if (this.startDate && this.endDate.isBefore(this.startDate, 'day')) {
      this.setDateFormControlError();
    } else {
      this.handleApplyFilters();

      this.removeFormControlError();
    }
  }

  setTabularConfigs() {
    this.tabularConfig = this.commonService.getConfigForElementKey(this.config, 'Tabular Section');
    this.tabularConfigObj = {};
    for (const configData of this.tabularConfig.elementConfigList) {
      this.tabularConfigObj[configData.elementKey] = configData.config;
    }
  }

  checkViewButtonVisibility(booking) {
    if (this.authService.user.role === 'VENDOR_MANAGER') {
      return booking.documentUploadStatus === 'SUPPORTING_DOCUMENTS_UPLOADED' ||
        booking.documentUploadStatus === 'INVOICE_UPLOADED';
    }
    return booking.invoiceApprStatus !== 'NOT_REQUIRED_FOR_NOW';
  }

  setBulkActionsConfigs() {
    if (this.bulkInvoiceActions) {
      this.bulkInvoiceActionsObj = {};
      for (const configData of this.bulkInvoiceActions.elementConfigList) {
        this.bulkInvoiceActionsObj[configData.elementKey] = configData.config;
      }
    }
  }

  setReasonConfig(config: any) {
    const reasonConfigSection = this.commonService.getConfigForElementKey(config, 'Booking Action Popup');
    this.rejectinvoiceReasonConfig = this.commonService.getConfigForElementKey(reasonConfigSection, 'Reject Invoice');
    // TODO nanju
    this.approveinvoiceReasonConfig = this.commonService.getConfigForElementKey(reasonConfigSection, 'Reject Invoice');
  }


  getDisableActionsConfig() {
    this.commonService.fetchDisableActionsConfig().subscribe((response: any) => {
      this.disableActionsConfig = response;
      this.getInvoiceDetails();
    });
  }

  setDateFilters() {
    const startDateConfig = this.commonService.getConfigForElementKey(this.invoiceFilterConfig, 'Start Date').config.defaultValue;
    const endDateConfig = this.commonService.getConfigForElementKey(this.invoiceFilterConfig, 'End Date').config.defaultValue;

    this.startDate = this.utilService.getMoment().add(Number(startDateConfig), 'days');
    this.endDate = this.utilService.getMoment().add(Number(endDateConfig), 'days');
    this.inputControlStartDate = new FormControl([this.startDate]);
    this.inputControlEndDate = new FormControl([this.endDate]);

    this.dateMaxConfig = {
      startDate: this.startDate,
      endDate: this.endDate,
    };
  }


  getBookingActionConfig() {
    this.invoiceActionBtnConfig = this.commonService.getConfigForElementKey(this.config, 'Action Buttons');
    this.invoiceActionConfig = this.commonService.getConfigForElementKey(this.config, 'Action Ellipsis');
    this.invoiceActionBtnConfigObj = {};
    this.invoiceActionsConfigObj = {};
    for (const configData of this.invoiceActionBtnConfig.elementConfigList) {
      this.invoiceActionBtnConfigObj[configData.elementKey] = configData.config;
    }
    for (const configData of this.invoiceActionConfig.elementConfigList) {
      this.invoiceActionsConfigObj[configData.elementKey] = configData.config;
    }
  }

  paymentSuccess(msg: any, booking) {
    booking['paymentStatus'] = "PROCESSING";
    this.showSuccessMessage = true;
    this.changeDetectorRef.detectChanges();
  }

  pageChanged(event) {
    this.currentPage = (event - 1);
    this.getInvoiceDetails();
  }
  editTripState(booking) {
    let tripStatus = false;
    if (booking['tripBillingStatus'] !== 'ACTIVE'
      && booking['tripStatus'] !== 'MANUALLY_COMPLETED') {
      tripStatus = true;
    } else if (booking['tripStatus'] === 'MANUALLY_COMPLETED' || booking['tripStatus'] === 'TRIP_NO_SHOW') {
      tripStatus = false;
    }
    if (this.commonService.workflowConfig['riderInvoiceApproval'] && booking['riderInvoiceApprovalStatus'] === 'REJECTED') {
      tripStatus = false;
    } else if (this.commonService.workflowConfig['invoiceApproval'] && booking['invoiceApprStatus'] === 'APPROVED') {
      tripStatus = true;
    } else if (booking['paymentStatus'] === 'PAID') {
      tripStatus = true;
    }
    return tripStatus;
  }
  getTripStatus(booking) {
    if (booking.startTime) {
      const dateMoment = this.utilService.findTimeDiffInMinutes(booking.startTime);
      if (dateMoment < -360 && booking['tripStatus'] !== 'ON_TRIP') {
        return 'EXPIRED';
      }
      else if (dateMoment <= -(this.manualCutOff) && (booking['tripStatus'] === 'UPCOMING')) {
        return 'MANUALLY END';
      }
      else {
        return booking.tripStatus;
      }
    }
  }
  endTrip(booking) {
    this.isLoading = true;
    this.commonService.postBulkBookingUpdate(this.getPostData(booking)).subscribe((response) => {
      this.isLoading = false;
      this.setStatusForUpdatedInvoice('MANUALLY_COMPLETED', [response[0]['bookingId']]);
    });
  }

  getPostData(booking) {
    const returnInfo = [];
    const data = {};
    data['bookingId'] = booking.bookingId ? booking.bookingId : '';
    data['modifierGuid'] = this.authService.user.employeeGuid;
    data['modifierBuid'] = this.authService.user.buId;
    data['action'] = 'trip_status_update';
    data['tripStatus'] = 'MANUALLY_COMPLETED';
    returnInfo.push(data);
    return returnInfo;
  }
  getInvoiceDetails(searchString = "") {
    this.isLoading = true;
    const queryParams = {
      startDate: this.startDate.format('DD-MM-YYYY'),
      endDate: this.endDate.format('DD-MM-YYYY'),
      client: this.authService.client.client,
      pageNum: this.currentPage,
      pageSize: this.pageSize,
      searchText: searchString,
    };
    const bookingType = this.formDetails.get('bookingType').value || 'All';
    const city = this.formDetails.get('city').value || 'All';
    const office = this.formDetails.get('office').value || null;
    // const contractType = this.formDetails.get('contractType').value;
    const request = {
      buID: this.authService.user.buId,
      city,
      contractType: "All",
      office,
      spotBookingType: bookingType,
    };
    if (this.authService.isUserVendor()) {
      request['employeeGuid'] = this.authService.user.employeeGuid;
    }
    if (this.invoiceTimer) {
      clearTimeout(this.invoiceTimer);
    }

    this.isLoading = true;
    this.invoiceViewService.fetchInvoiceDetails(queryParams, request).subscribe((response) => {
      clearInterval(this.lastUpdateInterval);
      this.now = 0;
      this.invoiceDetails = response['spotBookingDTO'];
      this.filteredInvoiceDetails = this.invoiceDetails;
      this.totalNoOfRows = this.invoiceDetails.length;
      this.totalPages = response['paginationCount'];
      this.setBookingAdditionalInfo();
      this.sortBookings(this.sortAscending);
      this.inputControlEndDate.markAsPristine();
      this.inputControlStartDate.markAsPristine();
      this.isLoading = false;
      if (!searchString) { this.showInvoiceActionToasts(); }
      this.lastUpdateInterval = setInterval(() => {
        this.now += 10;
      }, 10000);
      this.isAutoReload = false;
      // Auto reload
      this.invoiceTimer = setTimeout(() => {
        this.isAutoReload = true;
        this.searchInput = "";
        this.getInvoiceDetails();
      }, 120000); // 120000
    }, (error) => {
      this.isLoading = false;
    });
  }

  showInvoiceActionToasts() {
    if (this.state && this.state.updatedInvoice) {
      this.invoiceToastMessage = 'Invoice updated successfully';
      this.state = null;
    }
    this.router.navigate(['/invoicing']);
  }

  setBookingAdditionalInfo() {
    for (const booking of this.invoiceDetails) {
      booking['displayDate'] = this.getInvoiceDate(booking);

      if (this.miscellConfig['billAmountFrom'] && this.miscellConfig['billAmountFrom'] === 'Vendor') {
        booking['bookingAmount'] = booking['vendorBillAmount'] ? booking['vendorBillAmount'] : null;
      }

      if (booking.paymentAmount) {
        booking['paymentAmountInRupee'] = Number(booking.paymentAmount) / 100;
        booking.paymentAmountInRupee = Number(booking.paymentAmountInRupee).toFixed(2);
      }
      if (booking.vendorBillAmount) {
        booking['vendorBillAmountInRupee'] = Number(booking.vendorBillAmount) / 100;
        booking.vendorBillAmountInRupee = Number(booking.vendorBillAmountInRupee).toFixed(2);
      }
      // set actions disabled
      for (const disbaleAction of this.disableActionsConfig) {
        let disableActionForBooking = false;
        for (const actionStatus of disbaleAction.Disable) {
          const bookingStatus = booking[actionStatus.Status];
          const index = actionStatus.Values.indexOf(bookingStatus);
          if (index >= 0) {
            disableActionForBooking = true;
            break;
          }
        }
        booking[disbaleAction.Action + '-disable'] = disableActionForBooking ? true : false;
      }
    }
  }
  getEtsData() {
    this.commonService.getEtsData().subscribe((response) => {
      this.offices = response.offices;
      this.getOfficeOptionsEts();
    });
  }

  getOfficeOptionsEts() {
    this.officeOptions = Object.assign([], this.offices);
    this.officeOptions.push({
      address: 'All',
      guid: 'All'
    });
  }

  getOfficeValue(office: any) {
    return office.address;
  }

  getOfficeLabel(office: any) {
    return office.address;
  }

  onStartDateChange(dateValue: any) {
    this.startDate = dateValue.next[0];
    this.inputControlStartDate.markAsDirty();
    this.inputControlEndDate.markAsDirty();
    if (this.endDate && this.startDate.isAfter(this.endDate, 'day')) {
      this.setDateFormControlError();
    } else {
      this.removeFormControlError();
    }
  }

  setDateFormControlError() {
    this.inputControlStartDate.setErrors({ incorrectStartDate: true });
    this.inputControlEndDate.setErrors({ incorrectEndDate: true });
    this.displayInvalidDateError = true;
  }

  removeFormControlError() {
    this.inputControlEndDate.setErrors(null);
    this.inputControlStartDate.setErrors(null);
    this.displayInvalidDateError = false;
  }

  onEndDateChange(dateValue: any) {
    this.endDate = dateValue.next[0];
    this.inputControlStartDate.markAsDirty();
    this.inputControlEndDate.markAsDirty();

    if (this.startDate && this.endDate.isBefore(this.startDate, 'day')) {
      this.setDateFormControlError();
    } else {
      this.removeFormControlError();
    }
  }

  resetPagination() {
    this.currentPage = 0;
    this.totalPages = 0;
  }

  onSearchInputChange(event) {
    if (event.keyCode === 13 && this.searchInput && this.searchInput.length > 2) {
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }
      this.searchTimeout = setTimeout(this.searchInvoicesCall.bind(this), 500);
    }
    else if (this.searchInput === "") {
      this.resetPagination();
      this.getInvoiceDetails();
    }
  }

  searchInvoicesCall() {
    this.resetPagination();
    this.getInvoiceDetails(this.searchInput);
  }

  toggleHeader() {
    this.showHeader = !this.showHeader;
  }

  getInvoiceDate(booking: any) {
    if (booking.startTime) {
      const dateMoment = this.utilService.getMoment(booking.startTime);
      return dateMoment.format('DD/MM/YY');
    }
    return '';
  }

  handleAllBookingsSelected(data: any) {
    this.allInvoicesSelected = data.checked;
    const selectedInvoicesTemp = [];
    const selectedInvoicesDetailedTemp = [];

    if (this.showCheckboxHyphen) {
      this.showCheckboxHyphen = false;
    }
    if (data.checked) {
      for (const booking of this.invoiceDetails) {
        selectedInvoicesTemp.push(booking.bookingId);
        selectedInvoicesDetailedTemp.push(booking);
      }
      this.selectedInvoices = selectedInvoicesTemp;
      this.selectedInvoiceDetailed = selectedInvoicesDetailedTemp;
    } else {
      this.selectedInvoices = [];
      this.selectedInvoiceDetailed = [];
    }
  }

  handleBookingsSelected(data: any) {
    const selectedInvoicesTemp = this.selectedInvoices;
    let selectedInvoicesDetailedTemp = this.selectedInvoiceDetailed;
    if (data.checked) {
      selectedInvoicesTemp.push(data.value);
      for (const booking of this.invoiceDetails) {
        if (booking.bookingId === data.value) {
          selectedInvoicesDetailedTemp.push(booking);
          break;
        }
      }
      this.selectedInvoices = selectedInvoicesTemp;
      this.selectedInvoiceDetailed = selectedInvoicesDetailedTemp;
    } else {
      const index = this.selectedInvoices.indexOf(data.value);
      if (index > -1) {
        this.selectedInvoices.splice(index, 1);
      }
      selectedInvoicesDetailedTemp = this.selectedInvoiceDetailed.filter((booking) => {
        return booking.bookingId === data.value ? false : true;
      });
      this.selectedInvoiceDetailed = selectedInvoicesDetailedTemp;
    }
    this.handleMarkHeaderCheckbox();
  }

  selectVendorAssignedBookings() {
    const newselectedInvoices = [];
    const newselectedInvoicesDetailed = [];
    for (const booking of this.invoiceDetails) {
      if (booking.vendor) {
        newselectedInvoices.push(booking.bookingId);
        newselectedInvoicesDetailed.push(booking);
      }
    }
    this.selectedInvoices = newselectedInvoices;
    this.selectedInvoiceDetailed = newselectedInvoicesDetailed;
    this.handleMarkHeaderCheckbox();
  }

  selectVendorUnAssignedBookings() {
    const newselectedInvoices = [];
    const newselectedInvoicesDetailed = [];
    for (const booking of this.invoiceDetails) {
      if (!booking.vendor) {
        newselectedInvoices.push(booking.bookingId);
        newselectedInvoicesDetailed.push(booking);
      }
    }
    this.selectedInvoices = newselectedInvoices;
    this.selectedInvoiceDetailed = newselectedInvoicesDetailed;
    this.handleMarkHeaderCheckbox();
  }

  handleMarkHeaderCheckbox() {
    if (this.selectedInvoices.length && this.selectedInvoices.length === this.invoiceDetails.length) {
      this.allInvoicesSelected = true;
      this.showCheckboxHyphen = false;
    } else if (this.selectedInvoices.length === 0) {
      this.allInvoicesSelected = false;
      this.showCheckboxHyphen = false;
    } else {
      this.allInvoicesSelected = false;
      this.showCheckboxHyphen = true;
    }
  }

  isInvoiceChecked(booking: any) {
    const index = this.selectedInvoices.indexOf(booking.id);
    if (index > -1) {
      return true;
    }
    return false;
  }

  sortBookings(sortValue?: any) {
    this.sortAscending = sortValue || !this.sortAscending;
    if (this.sortAscending) {
      this.invoiceDetails.sort((a, b) => this.utilService.getMoment(a.startTime) - this.utilService.getMoment(b.startTime));
    } else {
      this.invoiceDetails.sort((a, b) => this.utilService.getMoment(b.startTime) - this.utilService.getMoment(a.startTime));
    }
  }

  handleEditInvoice(booking: any) {
    const navigationExtras: NavigationExtras = {
      state: {
        tripStatus: booking.tripStatus,
        isNoShowEnable: this.commonService.workflowConfig['enableEditTripParamsForNoShowTrips']
      },
      queryParams: { bookingId: booking.bookingId }
    };
    this.router.navigate(['invoicing/edit'], navigationExtras);
  }

  viewDocument(booking: any) {
    const navigationExtras: NavigationExtras = {
      state: {
        invoiceStatus: booking.invoiceApprStatus,
        vendorBillAmount: booking.vendorBillAmount,
        paymentAmount: booking.paymentAmount
      },
      queryParams: { bookingId: booking.bookingId }
    };
    this.router.navigate(['invoicing/viewDocument'], navigationExtras);
  }

  generateInvoice(booking: any) {
    const queryParams = {
      bookingID: booking.bookingId,
      buid: this.authService.user.buId,
      empGuid: this.authService.user.employeeGuid
    };
    this.isLoading = true;
    this.invoiceViewService.generateInvoice(queryParams).subscribe((response) => {
      this.isLoading = false;
      this.showSuccessToast = true;
      this.successMessage = "Invoice generated successfully";
      this.getInvoiceDetails(this.searchInput);
    }, (response) => {
      this.isLoading = false;
      this.showErrorDialog = true;
      this.errorMessage = response.error.message || 'Generate invoice failed';
    });
  }

  handleSendInvoice(booking: any) {
    this.isSendCommVisible = true;
    this.sendInvoiceBookings = [booking];
  }

  onSendInvoiceClick() {
    this.isSendCommVisible = !this.isSendCommVisible;
    this.sendInvoiceBookings = this.selectedInvoiceDetailed;
  }

  hideSendComm() {
    this.isSendCommVisible = !this.isSendCommVisible;
    // this.sendInvoiceBookings = null;
  }

  sendInvoice(request) {
    this.isSpinning = true;
    this.invoiceViewService.sendInvoice(request).subscribe((response) => {
      this.isSpinning = false;
      this.showSuccessToast = true;
      this.successMessage = "Invoice sent successfully";
      this.hideSendComm();
    }, (response) => {
      this.isSpinning = false;
      this.hideSendComm();
      this.showErrorDialog = true;
      this.errorMessage = response.error.message || 'Send invoice failed';
    });
  }

  downloadInvoice(booking: any) {
    const queryParams = {
      bookingID: booking.bookingId,
      client: this.authService.client.client,
      buid: this.authService.user.buId,
      empGuid: this.authService.user.employeeGuid
    };
    this.isLoading = true;
    this.invoiceViewService.downloadInvoice(queryParams).subscribe((response: any) => {
      this.isLoading = false;
      this.utilService.openUrlInNewTab(response);
    }, (response) => {
      this.isLoading = false;
      this.showErrorDialog = true;
      this.errorMessage = response.error.message || 'Download invoice failed';
    });
  }
  toggleLoading(value: any) {
    // this.isLoading = value;
    this.isSpinning = value;
  }

  handleDownlodSignInReport() {
    const searchQuery = {
      startDate: this.startDate.format('DD-MM-YYYY'),
      endDate: this.endDate.format('DD-MM-YYYY'),
      buid: this.authService.user.buId,
      client: this.authService.client.client,
    };
    const bookingType = this.formDetails ? this.formDetails.get('bookingType').value : ['All'];
    const city = this.formDetails ? this.formDetails.get('city').value : ['All'];
    const office = this.formDetails && this.formDetails.get('office').value
      ? this.formDetails.get('office').value : null;
    const vendorCabStatus = this.formDetails ? this.formDetails.get('vendorCabStatus').value : ['All'];
    const postBody = {
      bookingType,
      city,
      office,
      status: vendorCabStatus,
      buId: this.authService.user.buId,
      clientId: this.authService.client.client,
      employeeGUID: this.authService.user.employeeGuid
    };
    this.toggleLoading(true);
    this.bookingActionsHeaderService.downloadSignInReport(searchQuery, postBody).subscribe((response: any) => {
      this.downloadAsCsvService.downloadcsvFile(response);
      this.toggleLoading(false);
    }, (response) => {
      this.toggleLoading(false);
      this.downloadReportFailed = "SignInReport download failed";
    });
  }

  handleDownloadBookingReport() {
    const searchQuery = {
      startDate: this.startDate.format('DD-MM-YYYY'),
      endDate: this.endDate.format('DD-MM-YYYY')
    };
    const bookingType = this.formDetails ? this.formDetails.get('bookingType').value : ['All'];
    const city = this.formDetails ? this.formDetails.get('city').value : ['All'];
    const office = this.formDetails && this.formDetails.get('office').value
      ? this.formDetails.get('office').value : null;
    const vendorCabStatus = this.formDetails ? this.formDetails.get('vendorCabStatus').value : ['All'];
    const postBody = {
      bookingType,
      city,
      office,
      status: vendorCabStatus,
      buId: this.authService.user.buId,
      clientId: this.authService.client.client,
      employeeGUID: this.authService.user.employeeGuid
    };

    this.toggleLoading(true);
    this.bookingActionsHeaderService.downloadBookingDetails(searchQuery, postBody).subscribe((response: any) => {
      this.toggleLoading(false);
      this.commonBillingService.downloadBlob(response);
    }, (response) => {
      this.toggleLoading(false);
      this.downloadReportFailed = "Report download failed";
    });
  }

  hideDownloadReportError() {
    this.downloadReportFailed = '';
  }

  dismissError = () => {
    this.showErrorDialog = false;
    this.errorMessage = null;
  }

  toggleToast = () => {
    this.showSuccessToast = false;
    this.successMessage = null;
  }

  toggleInvoiceActionToast = () => {
    this.invoiceToastMessage = '';
  }

  handleApplyFilters() {
    this.resetPagination();
    this.getInvoiceDetails();
  }

  handleShowSingleBookingDetails(booking: any) {
    this.showBookingDetails = true;
    if (booking) {
      this.singleBookingDetails = booking;
    }
  }

  handleCloseBookingDetails() {
    this.showBookingDetails = false;
  }

  setPostData(status: string, bookings: any[]) {
    const returnArr = [];
    const bookingsArr = bookings || this.selectedInvoices;
    if (bookingsArr.length) {
      for (const bookingId of bookingsArr) {
        returnArr.push({
          approvalStatus: status,
          bookingID: bookingId,
          modifierBuid: this.authService.user.buId,
          modifierGuid: this.authService.user.employeeGuid
        });
      }
    }
    return returnArr;
  }

  approveInvoice(status) {
    this.postBulkUpdate(this.postDataForApproval, status);
  }

  submitReason(status) {
    this.isSubmitReasonClicked = true;
    if ((status === 'REJECTED' && this.rejectinvoiceReasonConfig && this.rejectinvoiceReasonConfig.config.mandatory) ||
      (status === 'APPROVED' && this.approveinvoiceReasonConfig && this.approveinvoiceReasonConfig.config.mandatory)) {
      if (this.reasonText && this.reasonText.length <= this.maxLimit) {
        this.isSpinning = true;
        this.postDataForApproval.forEach((data) => {
          data["reasonText"] = this.reasonText;
        });
        this.postBulkUpdate(this.postDataForApproval, status);
      }
    }
    else {
      if (this.reasonText) {
        if (this.reasonText.length <= this.maxLimit) {
          this.isLoading = true;
          this.postDataForApproval.forEach((data) => {
            data["reasonText"] = this.reasonText;
          });
          this.postBulkUpdate(this.postDataForApproval, status);
        }
      } else {
        this.isLoading = true;
        this.postDataForApproval.forEach((data) => {
          data["reasonText"] = "";
        });
        this.postBulkUpdate(this.postDataForApproval, status);
      }
    }
  }

  closeModal() {
    this.nonEligibleBookings = [];
    this.eligibleBookings = [];
    this.showApproveModal = false;
    this.showRejectModal = false;
    this.showRejectReasonBlock = false;
    this.showApproveReasonBlock = false;
    this.approveReasonForAmountMismatch = false;
    this.showModal = false;
    this.reasonText = "";
    this.isSubmitReasonClicked = false;
    this.singleRejectedBooking = [];
    this.showErrorDialog = false;
    this.toggleAutoReload(false);
  }

  getEligibleBookings(key) {
    this.selectedInvoiceDetailed.forEach((el) => {
      if (el[key]) {
        this.nonEligibleBookings.push(el.bookingId);
      } else {
        this.eligibleBookings.push(el.bookingId);
      }
    });
  }

  updateInvoiceStatus(status: string, booking?: any) {
    let postData, bookings;
    if (booking) {
      bookings = [booking.bookingId];
    }
    if (status === 'APPROVED' && !bookings) {
      this.approveReasonForAmountMismatch = this.commonService.workflowConfig['vendorInvoiceUpload'] && this.checkIfAmountAreDifferent(this.selectedInvoiceDetailed, 'Approve Invoice-disable');
      this.approveinvoiceReasonConfig.config.mandatory = this.approveinvoiceReasonConfig.config.mandatory || this.approveReasonForAmountMismatch;
      this.getEligibleBookings('Approve Invoice-disable');
      postData = this.setPostData(status, this.eligibleBookings);
      this.postDataForApproval = postData;
      this.showApproveModal = true;
      this.showModal = true;
    } else if (status === 'REJECTED' && !bookings) {
      this.getEligibleBookings('Reject Invoice-disable');
      postData = this.setPostData(status, this.eligibleBookings);
      this.postDataForApproval = postData;
      this.showRejectModal = true;
      this.showModal = true;
    } else {
      if (status === 'REJECTED') {
        this.showRejectModal = true;
        postData = this.setPostData(status, bookings);
        this.singleRejectedBooking = bookings;
        this.postDataForApproval = postData;
        this.showModal = true;
        this.showRejectReasonBlock = true;
      } else if (status === 'APPROVED') {
        this.approveReasonForAmountMismatch = this.commonService.workflowConfig['vendorInvoiceUpload'] && this.checkIfAmountAreDifferent([booking], 'Approve Invoice-disable');
        this.approveinvoiceReasonConfig.config.mandatory = this.approveinvoiceReasonConfig.config.mandatory || this.approveReasonForAmountMismatch;
        this.showApproveModal = true;
        postData = this.setPostData(status, bookings);
        this.postDataForApproval = postData;
        this.showModal = true;
        this.showApproveReasonBlock = true;
      } else {
        postData = this.setPostData(status, bookings);
      }
    }
    if (postData.length && !this.showApproveModal
      && !this.showRejectModal) {
      this.postBulkUpdate(postData, status, bookings);
    } else {
      this.selectedInvoices = [];
      this.selectedInvoiceDetailed = [];
      this.handleMarkHeaderCheckbox();
    }
    this.toggleAutoReload(true);
  }

  checkIfAmountAreDifferent(bookings, field?: string) {
    let amountDifferent = false;
    if (bookings) {
      bookings.forEach(booking => {
        if (!booking[field]) {
          if (Number(booking.vendorBillAmount) != Number(booking.paymentAmount)) {
            amountDifferent = true;
          }
        }
      });
    }
    return amountDifferent;
  }

  postBulkUpdate(postData, status, bookings?: any) {
    this.isSpinning = true;
    this.invoiceViewService.updateInvoiceStatus(postData).subscribe((response) => {
      this.isLoading = false;
      this.isSpinning = false;
      this.setStatusForUpdatedInvoice(status, bookings);
      this.selectedInvoices = [];
      this.selectedInvoiceDetailed = [];
      this.handleMarkHeaderCheckbox();
      this.setBookingAdditionalInfo();
      this.nonEligibleBookings = [];
      this.eligibleBookings = [];
      this.singleRejectedBooking = [];
      this.showApproveModal = false;
      this.showRejectModal = false;
      this.showRejectReasonBlock = false;
      this.showApproveReasonBlock = false;
      this.approveReasonForAmountMismatch = false;
      this.showModal = false;
      this.reasonText = "";
      this.isSubmitReasonClicked = false;
      this.toggleAutoReload(false);
      this.getInvoiceDetails();
    }, (response) => {
      this.errorMessage = response.error.message || 'Failed to update invoice status';
      this.showErrorDialog = true;
      this.isLoading = false;
      this.isSpinning = false;
      this.selectedInvoices = [];
      this.selectedInvoiceDetailed = [];
      this.nonEligibleBookings = [];
      this.singleRejectedBooking = [];
      this.eligibleBookings = [];
      this.showApproveModal = false;
      this.showRejectModal = false;
      this.showRejectReasonBlock = false;
      this.showApproveReasonBlock = false;
      this.approveReasonForAmountMismatch = false;
      this.showModal = false;
      this.isSubmitReasonClicked = false;
      this.handleMarkHeaderCheckbox();
      this.toggleAutoReload(false);
    });
  }

  setStatusForUpdatedInvoice(status: string, bookings?: any) {
    const bookingIdMapInfo = {};
    const bookingsArr = bookings || this.singleRejectedBooking || this.eligibleBookings || this.selectedInvoices;
    this.invoiceDetails.map((booking) => {
      bookingIdMapInfo[booking.bookingId] = booking;
    });

    for (const bookingId of bookingsArr) {
      const bookingToUpdate = Object.assign({}, bookingIdMapInfo[bookingId]);

      if (status === 'MANUALLY_COMPLETED') {
        bookingToUpdate.tripStatus = status;
      } else {
        bookingToUpdate.invoiceApprStatus = status;
      }
      Object.assign(bookingIdMapInfo[bookingId], bookingToUpdate);
    }
  }

  toggleAutoReload(pauseAutoReload: boolean) {
    if (pauseAutoReload) {
      if (this.invoiceTimer) {
        clearTimeout(this.invoiceTimer);
      }
    } else {
      if (this.now >= 120) {
        this.isAutoReload = true;
        this.getInvoiceDetails();
      } else {
        const time = (120 - this.now) * 1000;
        this.invoiceTimer = setTimeout(() => {
          this.isAutoReload = true;
          this.getInvoiceDetails();
        }, time);
      }
    }
  }

  openDrawer(booking: any) {
    const drawerRef = this.drawerSvc.show(
      InvoiceSingleDetailsComponent,
      {
        data: booking,
        miscelleneousConfig: this.miscellConfig,
        method: (action) => {
          switch (action) {
            case 'edit': this.handleEditInvoice(booking); break;
            case 'generate': this.generateInvoice(booking); break;
            case 'viewDocument': this.viewDocument(booking); break;
            // case 'history': this.handleCloseBookingDetails(booking); break;
            case 'download': this.downloadInvoice(booking); break;
            case 'track': this.isTrackingVisible = true; break;
            default:
          }
        }
      },
      { width: "422px" }
    );

    drawerRef.afterClosed.subscribe();
  }

  toggleTracking() {
    this.isTrackingVisible = !this.isTrackingVisible;
  }
  pageChangedNew(event: number) {
    this.pageIndexNew = event;
    this.currentPage = event - 1;
    this.getInvoiceDetails();
    this.filteredInvoiceDetails = this.invoiceDetails.slice(this.pageIndexNew * this.currentPageSize - this.currentPageSize, this.pageIndexNew * this.currentPageSize);
  }

  showNumberOfRecords(size: number) {
    this.currentPageSize = size;
    this.pageIndexNew = 1;
    this.filteredInvoiceDetails = this.invoiceDetails.slice(this.pageIndexNew * this.currentPageSize - this.currentPageSize, this.pageIndexNew * this.currentPageSize);
  }

  downloadReport(event){
    switch (event.label){
    case "Sign-In Report": this.handleDownlodSignInReport(); break;
    case "Booking Report": this.handleDownloadBookingReport(); break;
   }
  }

  checkIfMarshalAssigned(booking){
    booking.stops?.forEach(stop => {
      stop.riders?.forEach(rider => {
        this.marshalAssigned = rider.riderType === 'MARSHAL' 
      });
    });
    return this.marshalAssigned ? this.marshallAssignedIcon : this.marshallRequestedIcon;
  }

  ngOnDestroy() {
    if (this.invoiceTimer) {
      clearTimeout(this.invoiceTimer);
    }
  }
}
